// extracted by mini-css-extract-plugin
export default {"composeDialog":"dialog_composeDialog__eWoDr"};